import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const target = location.pathname === "/" || location.pathname === "/login" ? "/dashboard" : location.pathname + location.search;
    api.post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true, state: { user: data } });
      })
      .catch(() => setError("We couldn't complete sign-in. Please try again."));
  }, [location, navigate, setUser]);

  if (!error) return <div className="min-h-screen bg-[var(--pm-bg)]" />;
  return (
    <div className="min-h-screen grid place-items-center p-6" data-testid="auth-callback-error">
      <div className="pm-card p-8 text-center max-w-sm">
        <p className="font-bold mb-4">{error}</p>
        <a href="/login" className="pm-btn pm-btn-primary">Back to sign in</a>
      </div>
    </div>
  );
}
